import service from '@/utils/server';
let modelPath = '/mytask/recycling';
export const initPage = data => {
    return service({
        url: modelPath+'/initPage',
        method: 'post',
        data
    })
};



// WEBPACK FOOTER //
// ./src/page/mytask/recycling/api/index.js